import React from 'react';

const formatLastWinningPrice = (value) => {
  if (value === null || value === undefined || String(value).trim() === '') {
    return '-';
  }

  const parsedValue = Number(value);
  if (!Number.isFinite(parsedValue)) {
    return '-';
  }

  return `${parsedValue.toFixed(2)} RON`;
};

const formatWonAtDate = (value) => {
  if (!value) {
    return '';
  }

  const parsedDate = new Date(value);
  if (Number.isNaN(parsedDate.getTime())) {
    return '';
  }

  return parsedDate.toLocaleDateString('ro-RO');
};

export const buildLastWinningPriceMap = (payload) => {
  const items = Array.isArray(payload?.items) ? payload.items : [];

  return items.reduce((accumulator, item) => {
    const itemId = item?.necessity_list_item_id;
    if (!itemId) {
      return accumulator;
    }

    accumulator[String(itemId)] = {
      lastWinningPrice: item?.last_winning_price,
      wonAt: item?.won_at || null
    };

    return accumulator;
  }, {});
};

export const mergeLastWinningPricesIntoProducts = (products, lastWinningPriceMap) => {
  if (!Array.isArray(products) || !products.length) {
    return products;
  }

  const normalizedMap = lastWinningPriceMap || {};

  return products.map((product) => {
    const itemId = product?.originalData?.id;
    const lastWinningPriceData = itemId ? normalizedMap[String(itemId)] : null;

    return {
      ...product,
      lastWinningPrice: lastWinningPriceData?.lastWinningPrice ?? null,
      lastWinningWonAt: lastWinningPriceData?.wonAt ?? null
    };
  });
};

export const createLastWinningPriceColumn = (options = {}) => {
  const {
    title = 'Ultima achiziție',
    width = 170,
    className = 'biding__compact-cell'
  } = options;

  return {
    title,
    key: 'lastWinningPrice',
    width,
    className,
    render: (_, record) => {
      const priceLabel = formatLastWinningPrice(record?.lastWinningPrice);
      const wonAtLabel = formatWonAtDate(record?.lastWinningWonAt);

      if (priceLabel === '-') {
        return '-';
      }

      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <span>{priceLabel}</span>
          {wonAtLabel ? <small style={{ color: '#6b7280' }}>{wonAtLabel}</small> : null}
        </div>
      );
    }
  };
};
